import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MapPin, Phone, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/menu', label: 'Menu' },
    { path: '/family-meals', label: 'Family Meals' },
    { path: '/vape-products', label: 'Vape Products (21+)' },
    { path: '/location', label: 'Location' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <div 
              className="w-14 h-14 rounded-lg flex items-center justify-center relative overflow-hidden" 
              style={{ 
                background: 'linear-gradient(135deg, var(--marathon-blue) 0%, var(--marathon-red) 100%)'
              }}
            >
              <span className="text-white text-2xl font-black tracking-tight">HT</span>
            </div>
            <div>
              <div className="text-xl font-black" style={{ color: 'var(--marathon-blue)' }}>
                Hope Tobacco
              </div>
              <div className="text-xs font-medium" style={{ color: 'var(--gray-600)' }}>
                Marathon Gas • Krispy Krunchy Chicken • Vape & Tobacco
              </div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-12">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-all duration-200 ${
                  isActive(link.path) 
                    ? 'font-bold' 
                    : ''
                }`}
                style={{ 
                  color: isActive(link.path) ? 'var(--marathon-blue)' : 'var(--gray-700)',
                  borderBottom: isActive(link.path) ? '2px solid var(--marathon-red)' : '2px solid transparent',
                  paddingBottom: '6px',
                  paddingLeft: '8px',
                  paddingRight: '8px',
                  whiteSpace: 'nowrap'
                }}
                onMouseEnter={(e) => {
                  if (!isActive(link.path)) {
                    e.currentTarget.style.color = 'var(--marathon-blue)';
                    e.currentTarget.style.borderBottom = '2px solid var(--marathon-blue)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActive(link.path)) {
                    e.currentTarget.style.color = 'var(--gray-700)';
                    e.currentTarget.style.borderBottom = '2px solid transparent';
                  }
                }}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Contact Info */}
          <div className="hidden lg:flex items-center space-x-4">
            <a href="tel:8125465780" className="flex items-center space-x-2 text-sm" 
               style={{ color: 'var(--gray-700)' }}>
              <Phone size={16} style={{ color: 'var(--marathon-red)' }} />
              <span>(812) 546-5780</span>
            </a>
            <Link to="/location">
              <Button 
                size="sm"
                className="font-medium"
                style={{ 
                  background: 'linear-gradient(135deg, var(--marathon-blue) 0%, var(--marathon-red) 100%)',
                  color: 'white',
                  border: 'none'
                }}
              >
                Get Directions
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X size={24} style={{ color: 'var(--marathon-blue)' }} />
            ) : (
              <Menu size={24} style={{ color: 'var(--marathon-blue)' }} />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t" style={{ borderColor: 'var(--gray-200)' }}>
            <nav className="flex flex-col space-y-3">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-base font-medium py-2 ${
                    isActive(link.path) ? 'font-bold' : ''
                  }`}
                  style={{ color: isActive(link.path) ? 'var(--marathon-blue)' : 'var(--gray-700)' }}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
              <a href="tel:8125465780" className="flex items-center space-x-2 py-2 text-base" 
                 style={{ color: 'var(--gray-700)' }}>
                <Phone size={18} style={{ color: 'var(--marathon-red)' }} />
                <span>(812) 546-5780</span>
              </a>
              <Link to="/location" onClick={() => setMobileMenuOpen(false)}>
                <Button 
                  className="w-full font-medium"
                  style={{ 
                    background: 'linear-gradient(135deg, var(--marathon-blue) 0%, var(--marathon-red) 100%)',
                    color: 'white'
                  }}
                >
                  Get Directions
                </Button>
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
